import React from 'react';
import { branch, renderComponent } from 'recompose';

const Loading = () => (
    <div>Loading....</div>
);

export const withLoadingComponent = branch(
    props => props.loading || !props.loaded,
    renderComponent(Loading)
);

const Error = ({error}) => (
    <div>Error: {error.message}</div>
);

export const withErrorComponent = branch(
    props => props.error,
    renderComponent(Error)
);



// WEBPACK FOOTER //
// ./src/components/loading/index.js